import { __exportAll } from "../_virtual/_rolldown/runtime.js";
import { action, payload } from "ts-action";
//#region src/store/spa-app-actions.ts
var spa_app_actions_exports = /* @__PURE__ */ __exportAll({
	addLoadingState: () => addLoadingState,
	changeSubTask: () => changeSubTask,
	initIndexDBSuccess: () => initIndexDBSuccess,
	loginSuccess: () => loginSuccess,
	logoutSuccess: () => logoutSuccess,
	nologin: () => nologin,
	removeLoadingState: () => removeLoadingState,
	routeAction: () => routeAction,
	themeChanged: () => themeChanged,
	updateInternetOffline: () => updateInternetOffline,
	updateNewNotificationToken: () => updateNewNotificationToken,
	updateNewNotificationTokenFail: () => updateNewNotificationTokenFail,
	updateNewNotificationTokenSuccess: () => updateNewNotificationTokenSuccess
});
var initIndexDBSuccess = action("SPA_INIT_INDEX_DB_SUCCESS");
var loginSuccess = action("SPA_LOGIN_SUCCESS", payload());
var logoutSuccess = action("SPA_LOGOUT_SUCCESS");
var nologin = action("SPA_NO_LOGIN");
var routeAction = action("SPA_APP_ROUTE", payload());
/** Bridged from the document event PD_THEME_CHANGED_EVENT by PdSpaHelper. */
var themeChanged = action("SPA_THEME_CHANGED", payload());
var updateInternetOffline = action("SPA_APP_UPDATE_INTERNET_OFFLINE", payload());
var addLoadingState = action("SPA_APP_ADD_LOADING", payload());
var changeSubTask = action("SPA_APP_CHANGE_SUB_LOADING", payload());
var removeLoadingState = action("SPA_APP_REMOVE_LOADING", payload());
var updateNewNotificationToken = action("UPDATE_NOTIFICATION_TOKEN", payload());
var updateNewNotificationTokenSuccess = action("UPDATE_NOTIFICATION_TOKEN_SUCCESS", payload());
var updateNewNotificationTokenFail = action("UPDATE_NOTIFICATION_TOKEN_FAIL", payload());
//#endregion
export { addLoadingState, changeSubTask, initIndexDBSuccess, loginSuccess, logoutSuccess, nologin, removeLoadingState, routeAction, spa_app_actions_exports, themeChanged, updateInternetOffline, updateNewNotificationToken, updateNewNotificationTokenFail, updateNewNotificationTokenSuccess };
